import { render, staticRenderFns } from "./levelFivepageHDXX.vue?vue&type=template&id=9c5278ec&scoped=true&"
import script from "./levelFivepageHDXX.vue?vue&type=script&lang=js&"
export * from "./levelFivepageHDXX.vue?vue&type=script&lang=js&"
import style0 from "./levelFivepageHDXX.vue?vue&type=style&index=0&id=9c5278ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5278ec",
  null
  
)

export default component.exports